import React, { useState, useEffect } from 'react'

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem('theme')
    if (saved) return saved === 'dark'
    return window.matchMedia('(prefers-color-scheme: dark)').matches
  })

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }, [dark])

  return (
    <button
      onClick={() => setDark(d => !d)}
      aria-label="Toggle theme"
      className="fixed top-4 right-4 z-50 w-9 h-9 flex items-center justify-center
                 rounded-lg border border-card-border bg-card-bg text-muted
                 hover:text-title transition-colors shadow-sm"
    >
      <i className={dark ? 'ri-sun-line text-base' : 'ri-moon-line text-base'}></i>
    </button>
  )
}
